import React from 'react';
import { useNavigate } from 'react-router-dom';
import CasinoFloorHotspot from '../components/hotspots/CasinoFloorHotspot';
import SportsbookHotspot from '../components/hotspots/SportsbookHotspot';
import PokerRoomHotspot from '../components/hotspots/PokerRoomHotspot';

function Casino() {
  const navigate = useNavigate();

  return (
    <div className="page splash2 casinoPage">
      <div className="page-header">Casino</div>
      <div className="text-blocks">
        <div className="std-text">
          Tailor your patron engagement to every venue within your casino. Whether it's patron self-service using their own devices, or roaming servers equipped with all-in-one mobile order and payment devices. You can maximize gambling time with minimal interruptions.
        </div>
      </div>
      <div className="logo" onClick={() => navigate('/aboutus/agilysys')}>
        <img src="/assets/casino/Agilysys-Logo.svg" alt="Agilysys" style={{width:'100%',height:'auto'}} />
      </div>
      <div className="tap">
        <img src="/assets/casino/solutions/Green-Touch-Icon.gif" alt="" />
        <div className="tap-prompt">
          Tap on each section of the map{'\n'}To drill into the details
        </div>
      </div>
      <div className="casino-map">
        <div className="casino-floor">
          <CasinoFloorHotspot onClick={() => navigate('casino-floor')} />
        </div>
        <div className="sportsbook">
          <SportsbookHotspot onClick={() => navigate('sportsbook')} />
        </div>
        <div className="poker-room">
          <PokerRoomHotspot onClick={() => navigate('poker-room')} />
        </div>
      </div>
    </div>
  );
}

export default Casino;
